module.exports = __webpack_public_path__ + "static/media/ultrasound_probe_stablization_system-compressor.167254e9.jpg";